namespace advisorop.components.common {

    export class RmdTrackerController {
        allRmdTrackerInheritedData: Array<any>;
        allRmdTrackerNonInheritedData: Array<any>;
        rmdTrackerNonInheritedDetails: Array<any>;
        rmdTrackerInheritedDetails: Array<any>;
        advisoryFirmId: number;
        //issuesCount: number;
        //issuesInheritedCount: number;
        dg: DevExpress.ui.dxDataGridOptions;
        dgInherited: DevExpress.ui.dxDataGridOptions;
        advisoryFirms: domains.IAdvisoryFirm[];
        selFirm: domains.IAdvisoryFirm;
        selIRAType: number = 1;
        selRequirement: number = 1;
        asOfDate: string;

        // grid instances
        dgRmdTracker: DevExpress.ui.dxDataGrid;
        dgRmdInheritedTracker: DevExpress.ui.dxDataGrid;

        user: domains.IUser;
        isAdvisorUser: boolean = false;
        isServicerUser: boolean = false;

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#rmdTrackerContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        };

        ULT: { [key: number]: number } = {
            72: 27.4,
            73: 26.5,
            74: 25.5,
            75: 24.6,
            76: 23.7,
            77: 22.9,
            78: 22,
            79: 21.1,
            80: 20.2,
            81: 19.4,
            82: 18.5,
            83: 17.7,
            84: 16.8,
            85: 16,
            86: 15.2,
            87: 14.4,
            88: 13.7,
            89: 12.9,
            90: 12.2,
            91: 11.5,
            92: 10.8,
            93: 10.1,
            94: 9.5,
            95: 8.9,
            96: 8.4,
            97: 7.8,
            98: 7.3,
            99: 6.8,
            100: 6.4,
            101: 6,
            102: 5.6,
            103: 5.2,
            104: 4.9,
            105: 4.6,
            106: 4.3,
            107: 4.1,
            108: 3.9,
            109: 3.7,
            110: 3.5,
            111: 3.4,
            112: 3.3,
            113: 3.1,
            114: 3,
            115: 2.9,
            116: 2.8,
            117: 2.7,
            118: 2.5,
            119: 2.3,
            120: 2
        };

        static $inject = ["rmdTrackerApi", "servicerService", "advisorService", "generalService", "advisoryFirmApi", "identityService", "$rootScope"];
        constructor(
            private rmd: services.RmdTrackerApi,
            private servicerService: services.ServicerService,
            private advisorService: services.AdvisorService,
            private generalService: services.GeneralService,
            private advisoryFirmApi: services.AdvisoryFirmApi,
            private ids: services.IdentityService,
            private $rootScope: ng.IRootScopeService) {

            this.$rootScope.$on('adminModeChanged', (event: ng.IAngularEvent) => {
                this.loadRMDTracker();
            });


            this.dg = {
                export: {
                    enabled: true,
                    fileName: "RMDTracking"
                },
                bindingOptions: {
                    dataSource: "vm.rmdTrackerNonInheritedDetails",
                },
                //height: 400,
                scrolling: {
                    mode: "standard",
                    scrollByContent: true,
                    preloadEnabled: false,
                    useNative: true
                },
                paging: {
                    pageSize: 18,
                    enabled: true
                },
                rowAlternationEnabled: true,
                //width: 1000,
                showBorders: true,
                showColumnLines: true,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                selection: {
                    allowSelectAll: false,
                    mode: "single"
                },
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: ""
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: true },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                editing: {
                    allowUpdating: true,
                    allowDeleting: false,
                    allowAdding: false,
                    mode: "cell"
                },
                onInitialized: function (e: any) {
                    //console.log('Initialising...');
                    this.dgRmdTracker = e.component;
                },
                wordWrapEnabled: true,

                columns: [
                    { dataField: "investorName", caption: "Investor Name", allowEditing: false, sortIndex: 0, sortOrder: "asc", allowHeaderFiltering: false  },
                    { dataField: "id", caption: "Our Status", cellTemplate: "colActions", width: 65, allowEditing: false, allowHeaderFiltering: false  },
                    { dataField: "investorRmdStatus.notes", caption: "Notes", width: 340, allowEditing: true, allowHeaderFiltering: false  },
                    { dataField: "holderAge", caption: "Holder Age", width: 80, allowEditing: false, allowHeaderFiltering: false  },
                    { dataField: "currYearRMD", caption: "Curr Year RMD", format: "currency", width: 90, allowEditing: false, allowHeaderFiltering: false  },
                    { dataField: "ytdDistribution", caption: "YTD Distribution", format: "currency", width: 90, allowEditing: false, allowHeaderFiltering: false  },
                    { dataField: "remainingRMD", caption: "Remaining RMD", format: "currency", width: 90, allowEditing: false, allowHeaderFiltering: false  },
                    { dataField: "cashAvailable", caption: "Cash Available", format: "currency", width: 90, allowEditing: false, allowHeaderFiltering: false  },
                    { dataField: "advisorName", caption: "Advisor", allowEditing: false, allowHeaderFiltering: true },
                ],
                masterDetail: {
                    enabled: true,
                    template: "accounts",
                    autoExpandAll: false
                },
                onEditorPreparing: (e) => this.onep2(e),
                onRowUpdating: (e) => this.onUpdate(e),
            };

            this.dgInherited = {
                export: {
                    enabled: true,
                    fileName: "RMDTrackingInherited"
                },
                bindingOptions: {
                    dataSource: "vm.rmdTrackerInheritedDetails",
                },
                //height: 400,
                scrolling: {
                    mode: "standard",
                    scrollByContent: true,
                    preloadEnabled: false,
                    useNative: true
                },
                paging: {
                    pageSize: 50,
                    enabled: true
                },
                rowAlternationEnabled: true,
                //width: 1000,
                showBorders: true,
                showColumnLines: true,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                selection: {
                    allowSelectAll: false,
                    mode: "single"
                },
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: ""
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: true },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                editing: {
                    allowUpdating: true,
                    allowDeleting: false,
                    allowAdding: false,
                    mode: "cell"
                },
                onInitialized: function (e: any) {
                    //console.log('Initialising...');
                    this.dgRmdInheritedTracker = e.component;
                },
                wordWrapEnabled: true,

                columns: [
                    { dataField: "investorName", caption: "Investor Name", allowEditing: false, sortIndex: 0, sortOrder: "asc", allowHeaderFiltering: false },
                    { dataField: "holderAge", caption: "Age", width: 35, allowEditing: false, allowHeaderFiltering: false  },
                    { dataField: "accountName", caption: "Account Name", allowEditing: false, allowHeaderFiltering: false  },
                    { dataField: "id", caption: "Our Status", cellTemplate: "colInheritedActions", width: 55, allowEditing: false, allowHeaderFiltering: false  },
                    { dataField: "accountRmdStatus.notes", caption: "Notes", width: 100, allowEditing: true, allowHeaderFiltering: false  },
                    { dataField: "accountNumber", caption: "Account Number", allowEditing: false, allowHeaderFiltering: false  },
                    { dataField: "managerAndProduct", caption: "Product Description", allowEditing: false, allowHeaderFiltering: false  },
                    //{ dataField: "multipleRetirementAccountInd", caption: "Mult.Accts?", allowEditing: false },
                    { dataField: "periodicPaymentFlag", caption: "Periodic Pmt?", allowEditing: false, allowHeaderFiltering: false  },
                    { dataField: "status", caption: "Calcd. Status", allowEditing: false, allowHeaderFiltering: false  },
                    { dataField: "prevYearFMV", caption: "Prev Yr. FMV", format: "currency", width: 60, allowEditing: true, allowHeaderFiltering: false  },
                    { dataField: "currYearRMD", caption: "Curr Yr. RMD", format: "currency", width: 60, allowEditing: true, allowHeaderFiltering: false  },
                    { dataField: "ytdDistribution", caption: "YTD Dist.", format: "currency", width: 60, allowEditing: true, allowHeaderFiltering: false  },
                    { dataField: "remainingRMD", caption: "Remain. RMD", format: "currency", width: 60, allowEditing: false, allowHeaderFiltering: false  },
                    { dataField: "cashAvailable", caption: "Cash Avail.", format: "currency", width: 60, allowEditing: false, allowHeaderFiltering: false  },
                    { dataField: "advisorName", caption: "Advisor", allowEditing: false, allowHeaderFiltering: true  },
                ],
                masterDetail: {
                    enabled: false,
                    //template: "accounts",
                    //autoExpandAll: false
                },
                onEditorPreparing: (e) => this.onep(e),
                onRowUpdating: (e) => this.onru(e, true)
            };
        }

        // In the non-inherited detail accounts grid, change text color to red if the account is closed and there are multiple accounts... in this case
        // Pershing seems to roll the closed account balance and associated RMD into another open account. We are not including these amounts in the summary (master) grid line.
        oncp = (e: any) => {
            if (e.row == undefined) {
                return;
            }
            if (e.row.rowType === 'data') {
                var data = e.row.data;
                if (data.rmdListingStatus == "Deleted Acct" && data.multipleRetirementAccountInd == "YES")
                    e.cellElement.css("color", "red");
                //else
                //    e.cellElement.css("color", "black");
            }
        }

        // In the non-inherited detail accounts grid and the inherited main (account level) grid, disable ability to input data if the data is provided by the custodian
        onep = (e: any) => {
            if (e.row == undefined) {
                return;
            }
            if (e.row.rowType === 'data') {
                var data = e.row.data;
                if (!this.isServicerUser || (data.custodianProvidedData
                    && (e.dataField === 'prevYearFMV' || e.dataField === 'currYearRMD' || e.dataField === 'ytdDistribution'))) {
                    e.editorOptions.disabled = true;
                }
                if (!this.isServicerUser || (e.dataField === 'accountRmdStatus.notes' && !data.accountId)) {
                    e.editorOptions.disabled = true;
                }
            }
        }

        // In the non-inherited detail accounts grid and the inherited main (account level) grid, disable ability to input data if the data is provided by the custodian
        onep2 = (e: any) => {
            if (e.row == undefined) {
                return;
            }
            // Disable investor level notes update if not a servicer
            if (e.row.rowType === 'data' && !this.isServicerUser && e.dataField === 'investorRmdStatus.notes')
                e.editorOptions.disabled = true;
        }

        // account-level data has been updated
        onru = (e: any, inherited: boolean = false) => {
            if (!this.isServicerUser)
                return;

            // Make sure user entered numeric values
            //if (
            //    (e.newData.hasOwnProperty('prevYearFMV') && !(typeof e.newData.prevYearFMV === 'number'))
            //    || (e.newData.hasOwnProperty('currYearRMD') && !(typeof e.newData.currYearRMD === 'number'))
            //    || (e.newData.hasOwnProperty('ytdDistribution') && !(typeof e.newData.ytdDistribution === 'number'))
            //) {
            //    toastr.error("You must enter a numeric value");
            //    return;
            //}

            // Construct accountRmdStatus object to create/update based on the original data from the DB (if any),
            // combined with the newData from the control.
            //console.log("ATTEMPTING TO UPDATE E", e);

            var prevYearFMV = e.newData.hasOwnProperty('prevYearFMV') ? e.newData.prevYearFMV : e.oldData.hasOwnProperty('prevYearFMV') ? e.oldData.prevYearFMV : null;
            var currYearRMD = e.newData.hasOwnProperty('currYearRMD') ? e.newData.currYearRMD : e.oldData.hasOwnProperty('currYearRMD') ? e.oldData.currYearRMD : null;
            var ytdDistribution = e.newData.hasOwnProperty('ytdDistribution') ? e.newData.ytdDistribution : e.oldData.hasOwnProperty('ytdDistribution') ? e.oldData.ytdDistribution : null;
            var remainingRMD: number = null;
            var notes: string = null;
            if (e.newData.accountRmdStatus && e.newData.accountRmdStatus.notes != null) {
                notes = e.newData.accountRmdStatus.notes;
            } else if (e.oldData.accountRmdStatus && e.oldData.accountRmdStatus.notes != null) {
                notes = e.oldData.accountRmdStatus.notes
            }

            var acctRmdStatus = {} as domains.AccountRmdStatusViewModel;

            var existingRecord: any[] = null;
            var oldCurrYearRMD = 0;
            if (inherited === true) {
                existingRecord = this.allRmdTrackerInheritedData.filter(f => f.accountId == e.key.accountId);
            } else {
                this.allRmdTrackerNonInheritedData.forEach(f => {
                    var found = f.accounts.filter(ff => ff.accountId == e.key.accountId);
                    if (found.length > 0) {
                        existingRecord = f.accounts.filter(ff => ff.accountId == e.key.accountId);
                    }
                });

                // If user is updating Prev Year FMV then calculate the RMD usint ULT table based on investor's age
                if (e.newData.hasOwnProperty('prevYearFMV')) {
                    var masterRecord = this.allRmdTrackerNonInheritedData.filter(f => f.investorId == e.key.investorId)[0];
                    if (masterRecord) {
                        var investorAge = masterRecord.holderAge;
                        if (investorAge && investorAge > 0 && this.ULT.hasOwnProperty(investorAge)) {
                            var ultVal = this.ULT[investorAge];
                            currYearRMD = Math.round(e.newData.prevYearFMV / ultVal * 100) / 100;
                            if (existingRecord.length > 0) {
                                oldCurrYearRMD = existingRecord[0].currYearRMD;
                                existingRecord[0].currYearRMD = currYearRMD
                            }
                        }
                    }
                }
            }

            if (e.newData.hasOwnProperty('prevYearFMV') || e.newData.hasOwnProperty('currYearRMD') || e.newData.hasOwnProperty('ytdDistribution')) {
                if (currYearRMD != null && ytdDistribution != null)
                    remainingRMD = currYearRMD - ytdDistribution;
                else
                    remainingRMD = null;
            } else {
                remainingRMD = e.oldData.remainingRMD
            }

            if (existingRecord.length > 0 && existingRecord[0].accountRmdStatus != null) {
                //console.log("EXISTING ACCT RMD STATUS", existingRecord[0]);
                acctRmdStatus = existingRecord[0].accountRmdStatus;
                acctRmdStatus.prevYearFMV = prevYearFMV;
                acctRmdStatus.currYearRMD = currYearRMD;
                acctRmdStatus.ytdDistribution = ytdDistribution;
                acctRmdStatus.remainingRMD = remainingRMD;
                acctRmdStatus.notes = notes;
            } else {
                //console.log("ADDING NEW STATUS RECORD");
                var yr = e.oldData.asOfDate.substring(6, 10);
                acctRmdStatus = {
                    id: 0,
                    accountId: e.oldData.accountId,
                    year: +yr,
                    prevYearFMV: prevYearFMV,
                    currYearRMD: currYearRMD,
                    ytdDistribution: ytdDistribution,
                    remainingRMD: remainingRMD,
                    status: null,
                    notes: notes
                };
            }

            //console.log("DATA TO UPDATE", acctRmdStatus);
            this.updateAccountRMDStatus(e, acctRmdStatus, inherited);

            if (inherited !== true) {
                // find the master record and update it to reflect the summary of the child records
                var masterRecord = this.allRmdTrackerNonInheritedData.filter(f => f.investorId == e.key.investorId)[0];

                if (masterRecord) {
                    var changeInCYR = 0;
                    var changeInYTDD = 0;
                    if (e.newData.hasOwnProperty('prevYearFMV')) {
                        changeInCYR = currYearRMD - oldCurrYearRMD;
                        masterRecord.currYearRMD = masterRecord.currYearRMD + changeInCYR;
                    } else if (e.oldData.hasOwnProperty('currYearRMD')) {
                        changeInCYR = currYearRMD - e.oldData.currYearRMD;
                        masterRecord.currYearRMD = masterRecord.currYearRMD + changeInCYR;
                    }
                    if (e.oldData.hasOwnProperty('ytdDistribution')) {
                        changeInYTDD = ytdDistribution - e.oldData.ytdDistribution;
                        masterRecord.ytdDistribution = masterRecord.ytdDistribution + changeInYTDD;
                    }
                    if (e.oldData.hasOwnProperty('remainingRMD')) {
                        masterRecord.remainingRMD = masterRecord.currYearRMD - masterRecord.ytdDistribution
                    }
                }
            }
        }

        // Investor-level grid update supports update of notes only
        onUpdate = (e: any) => {
            if (!this.isServicerUser)
                return;

            // component, element, model, oldData, newData, key, 
            //console.log("Updating data...", e);

            var invRmdStatus = {} as domains.InvestorRmdStatusViewModel;
            if (!e.oldData.investorRmdStatus) {
                var yr = e.oldData.asOfDate.substring(6, 10);
                invRmdStatus = {
                    id: 0,
                    advisoryFirmId: e.oldData.advisoryFirmId,
                    inheritedFlag: e.oldData.inheritedFlag,
                    investorId: e.oldData.investorId,
                    notes: e.newData.investorRmdStatus.notes,
                    status: advisorop.domains.RmdStatus.UNMET,
                    year: +yr
                };
            } else {
                invRmdStatus = e.oldData.investorRmdStatus;
                invRmdStatus.notes = e.newData.investorRmdStatus.notes
            }
            this.updateInvestorRMDStatus(e, invRmdStatus);
        }

        changeNonInheritedRequirementMetStatus = (item: any, requirementMet: boolean) => {
            if (!this.isServicerUser)
                return;

            var invRmdStatus = {} as domains.InvestorRmdStatusViewModel;

            if (!item.investorRmdStatus) {
                var yr = item.asOfDate.substring(6, 10);
                invRmdStatus = {
                    id: 0,
                    advisoryFirmId: item.advisoryFirmId,
                    inheritedFlag: item.inheritedFlag,
                    investorId: item.investorId,
                    notes: "",
                    status: requirementMet == true ? advisorop.domains.RmdStatus.MET : advisorop.domains.RmdStatus.UNMET,
                    year: +yr
                };
            } else {
                invRmdStatus = item.investorRmdStatus;
                invRmdStatus.status = requirementMet == true ? advisorop.domains.RmdStatus.MET : advisorop.domains.RmdStatus.UNMET
            }

            this.servicerService.updateInvestorRMDStatus(invRmdStatus).then(response => {
                item.investorRmdStatus = response.data;
                let dg = DevExpress.ui.dxDataGrid.getInstance($('#dgRmdTracker')) as DevExpress.ui.dxDataGrid;
                if (dg) { dg.refresh(); }
                toastr.success("Investor RMD status has been updated.");

            }, err => this.generalService.showError(err));
        }

        changeInheritedRequirementMetStatus = (item: any, requirementMet: boolean) => {
            if (!this.isServicerUser)
                return;

            var acctRmdStatus = {} as domains.AccountRmdStatusViewModel;
            //console.log("THE ITEM IS", item);
            if (!item.accountRmdStatus) {
                var yr = item.asOfDate.substring(6, 10);
                acctRmdStatus = {
                    id: 0,
                    accountId: item.accountId,
                    prevYearFMV: null,
                    currYearRMD: null,
                    ytdDistribution: null,
                    remainingRMD: null,
                    notes: "",
                    status: requirementMet == true ? advisorop.domains.RmdStatus.MET : advisorop.domains.RmdStatus.UNMET,
                    year: +yr
                };
            } else {
                acctRmdStatus = item.accountRmdStatus;
                acctRmdStatus.status = requirementMet == true ? advisorop.domains.RmdStatus.MET : advisorop.domains.RmdStatus.UNMET
            }

            //console.log("UPDATING ACCT LEVEL STATUS", acctRmdStatus);

            this.servicerService.updateAccountRMDStatus(acctRmdStatus).then(response => {
                item.accountRmdStatus = response.data;
                let dg = DevExpress.ui.dxDataGrid.getInstance($('#dgRmdInheritedTracker')) as DevExpress.ui.dxDataGrid;
                if (dg) {dg.refresh();}
                toastr.success("Account RMD status has been updated.");

            }, err => this.generalService.showError(err));
        }

        updateInvestorRMDStatus(e: any, invRmdStatus: advisorop.domains.InvestorRmdStatusViewModel) {
            if (!this.isServicerUser)
                return;

            this.servicerService.updateInvestorRMDStatus(invRmdStatus).then(response => {
                e.oldData.investorRmdStatus = response.data;
                let dg = DevExpress.ui.dxDataGrid.getInstance($('#dgRmdTracker')) as DevExpress.ui.dxDataGrid;
                if (dg) {dg.refresh();}
                toastr.success("Investor RMD status has been updated.");

            }, err => this.generalService.showError(err));
        }

        updateAccountRMDStatus(e: any, acctRmdStatus: advisorop.domains.AccountRmdStatusViewModel, inherited: boolean) {
            if (!this.isServicerUser)
                return;

            //console.log("WANT TO UPDATE ACCOUNT RMD STATUS TO", acctRmdStatus);

            this.servicerService.updateAccountRMDStatus(acctRmdStatus).then(response => {

                // Update the main data structure and refresh the grid
                if (inherited) {
                    this.allRmdTrackerInheritedData.filter(f => f.accountId == response.data.accountId).forEach(v => {
                        v.accountRmdStatus = response.data as advisorop.domains.AccountRmdStatusViewModel;
                        v.prevYearFMV = response.data.prevYearFMV;
                        v.currYearRMD = response.data.currYearRMD;
                        v.ytdDistribution = response.data.ytdDistribution;
                        v.remainingRMD = response.data.remainingRMD;
                        v.notes = response.data.notes;
                        if (response.data.currYearRMD != null && response.data.ytdDistribution != null) {
                            if (response.data.currYearRMD - response.data.ytdDistribution <= 0) {
                                v.status = "MET";
                            } else {
                                v.status = "UNMET";
                            }
                        } else {
                            v.status = null;
                        }
                    });
                } else {
                    this.allRmdTrackerNonInheritedData.forEach(f => {
                        f.accounts.filter(ff => ff.accountId == e.key.accountId).forEach(v => {
                            v.accountRmdStatus = response.data as advisorop.domains.AccountRmdStatusViewModel;
                            v.prevYearFMV = response.data.prevYearFMV;
                            v.currYearRMD = response.data.currYearRMD;
                            v.ytdDistribution = response.data.ytdDistribution;
                            v.remainingRMD = response.data.remainingRMD;
                            v.notes = response.data.notes;
                            if (response.data.currYearRMD != null && response.data.ytdDistribution != null) {
                                if (response.data.currYearRMD - response.data.ytdDistribution <= 0) {
                                    v.status = "MET";
                                } else {
                                    v.status = "UNMET";
                                }
                            } else {
                                v.status = null;
                            }
                        })
                    })
                }

                toastr.success("Account RMD status has been updated.");

            }, err => this.generalService.showError(err));
        }

        loadRMDTracker(): void {
            this.asOfDate = "";

            let rez: any;

            this.isInitializing = true;

            //this.issuesCount = 0;

            if (this.advisoryFirmId && this.advisoryFirmId > 0) {
                var adminModeEnabled = false;
                if (this.isAdvisorUser) {
                    const adminMode = this.advisorService.getAdminMode();
                    adminModeEnabled = adminMode && adminMode.enabled;
                }

                //console.log("Loading RMD data for firm: " + this.advisoryFirmId);
                this.rmd.getRMDTrackingData(adminModeEnabled, this.advisoryFirmId).then(response => {
                    this.allRmdTrackerInheritedData = response.data?.inherited;
                    this.allRmdTrackerNonInheritedData = response.data?.nonInherited;
                    this.filterChanged();
                    this.isInitializing = false;
                    //console.log("INH DATA-----",this.allRmdTrackerInheritedData);
                }, err => this.isInitializing = false).catch(err => {
                    this.generalService.showError(err);
                });
            }
        }

        firmChanged(): void {
            this.advisoryFirmId = this.selFirm.id;
            this.loadRMDTracker();
        }

        filterChanged(): void {

            //console.log("ALL INH DATA", this.allRmdTrackerInheritedData);
            //console.log("ALL NON-INH DATA", this.allRmdTrackerNonInheritedData);
            if (this.allRmdTrackerNonInheritedData && this.allRmdTrackerNonInheritedData.length > 0) {
                this.asOfDate = this.allRmdTrackerNonInheritedData[0].asOfDate;
                if (this.selRequirement == 1)
                    this.rmdTrackerNonInheritedDetails = this.allRmdTrackerNonInheritedData;
                else if (this.selRequirement == 2)
                    this.rmdTrackerNonInheritedDetails = this.allRmdTrackerNonInheritedData.filter(w => !w.investorRmdStatus || w.investorRmdStatus.status === advisorop.domains.RmdStatus.UNMET);
                else if (this.selRequirement == 3)
                    this.rmdTrackerNonInheritedDetails = this.allRmdTrackerNonInheritedData.filter(w => w.investorRmdStatus && w.investorRmdStatus.status === advisorop.domains.RmdStatus.MET);
            } else {
                this.rmdTrackerNonInheritedDetails = [];
            }
            if (this.allRmdTrackerInheritedData && this.allRmdTrackerInheritedData.length > 0) {
                this.asOfDate = this.allRmdTrackerInheritedData[0].asOfDate;
                if (this.selRequirement == 1)
                    this.rmdTrackerInheritedDetails = this.allRmdTrackerInheritedData;
                else if (this.selRequirement == 2)
                    this.rmdTrackerInheritedDetails = this.allRmdTrackerInheritedData.filter(w => !w.accountRmdStatus || w.accountRmdStatus.status === advisorop.domains.RmdStatus.UNMET);
                else if (this.selRequirement == 3)
                    this.rmdTrackerInheritedDetails = this.allRmdTrackerInheritedData.filter(w => w.accountRmdStatus && w.accountRmdStatus.status === advisorop.domains.RmdStatus.MET);
            } else {
                this.rmdTrackerInheritedDetails = [];
            }
            //console.log("FILTERED");
            //console.log("FILTERED INH", this.rmdTrackerInheritedDetails);
            //console.log("FILTERED NON-INH", this.rmdTrackerNonInheritedDetails);

            //if (this.rmdTrackerNonInheritedDetails.length > 0) {
            //    this.issuesCount = this.rmdTrackerNonInheritedDetails.length;
            //    this.issuesInheritedCount = this.rmdTrackerInheritedDetails.length;
            //}
        }

        $onInit(): void {
            this.user = this.ids.getUser();

            this.isAdvisorUser = (
                this.user.role === "ADVISORY"
                || this.user.role === "ADVISORY_LEAD"
                || this.user.role === "ADVISORY_ADMIN"
            );

            this.isServicerUser = (
                this.user.role === "SERVICER_OPERATIONS"
                || this.user.role === "SERVICER_LEAD"
                || this.user.role === "SERVICER_ADMIN"
            );

            this.advisoryFirmApi.getAdvisoryFirms().then(response => {
                this.advisoryFirms = response.data;
                this.selFirm = this.advisoryFirms[0];
                this.firmChanged();
            }).catch(reason => {
            });
        }

        $onChanges(evt) {
            for (var key in evt) {
                //if (key === "advisoryFirmId" && this.advisoryFirmId) {
                //    console.log("advisoryFirmId Event");
                //}
            }
        };
    }


    class RmdTracker implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                //issuesCount: "="
            };
            this.controller = RmdTrackerController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/shared/common/rmd-tracker.html";
        }
    }
    angular.module(Constants.APP).component("rmdTracker", new RmdTracker());

}